function LoaderSpin({ size = 6, className }) {
  return (
    <div
      className={`h-${size} w-${size} animate-spin rounded-full border-2 border-neutral-100 border-t-neutral-700 ${className}`}
    />
  )
}

export default LoaderSpin
